import { render, staticRenderFns } from "./SubjectCreateDialog.vue?vue&type=template&id=3410ed51&scoped=true"
import script from "./SubjectCreateDialog.vue?vue&type=script&lang=js"
export * from "./SubjectCreateDialog.vue?vue&type=script&lang=js"
import style0 from "./SubjectCreateDialog.vue?vue&type=style&index=0&id=3410ed51&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3410ed51",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3410ed51')) {
      api.createRecord('3410ed51', component.options)
    } else {
      api.reload('3410ed51', component.options)
    }
    module.hot.accept("./SubjectCreateDialog.vue?vue&type=template&id=3410ed51&scoped=true", function () {
      api.rerender('3410ed51', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/SubjectCreateDialog.vue"
export default component.exports